var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"grade-button"},[_c('BaseText',[_vm._t("default")],2),_c('span',{staticClass:"grade-button__arrow"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }